// extracted by mini-css-extract-plugin
export default {"recos":"X2-z","productCardOverride":"Y2-z","rowHasBadge":"Z2-z"};